// extracted by mini-css-extract-plugin
module.exports = {"container":"IncludedBanner_container__iOSf7","logo":"IncludedBanner_logo__MSWK3"};